import AuthorityCommunication from '~/pages/communication/authority/libs/components/AuthorityCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const AuthorityCommunicationPage = (props: TPageProps) => (
  <AuthorityCommunication {...props} />
)

export default AuthorityCommunicationPage
